<div *ngIf="!compact" #containerDiv class="slick-drop-down form-control d-flex flex-fill align-items-center position-relative" 
     [slick-validation-indicator]="validationIndicator" 
     [slickValidationType]="validationIndicatorType" 
     id="slick-drop-down_{{uuid}}" 
     attr.data-uuid="{{uuid}}" 
     [class.open]="expanded || pickerOpen"
     (click)="onDropdownClicked($event)">

    <div *ngIf="icon" class="slick-drop-down_icon p-0" style="position: absolute;"><i class="px-1" [ngClass]="icon"></i></div>

    <!-- On a phone the text box only displays the choice: it can't take a tap or focus, so the
         keyboard never comes up, and the tap lands on the container, which opens the picker below -->
    <input #selectedTextInputRef *ngIf="!disabled" class='form-control ps-2 pe-4'
           [ngClass]="{'validation-border' : validationIndicatorType}"
           [class.ps-4]="!!icon"
           [(ngModel)]="selectedText"
           [readonly]="mobilePicker"
           [style.pointer-events]="mobilePicker ? 'none' : null"
           [attr.tabindex]="mobilePicker ? -1 : tabindex"
           (input)="onInput($event)"
           (keyup)="onKeyUp($event)" 
           (keydown)="onKeyDown($event)" 
           (focus)="onDropdownClicked($event)"  
           (click)="$event.stopPropagation()"
           [placeholder]='placeholder' />
    <input #selectedTextInputRef *ngIf="disabled" class='form-control ps-2 pe-4' 
           [class.ps-4]="!!icon" 
           disabled="disabled" 
           [ngModel]="selectedText" 
           tabindex="-1" 
           [readonly]="true" 
           [placeholder]='placeholder' />

    <div style="position: absolute; right: 0;">
        <i class="fal fa-chevron-down me-2" style="pointer-events: none"></i>
    </div>

</div>

<div *ngIf="compact" #containerDiv class="slick-drop-down slick-drop-down-compact form-control d-flex flex-fill align-items-center" 
     id="slick-drop-down_{{uuid}}" 
     attr.data-uuid="{{uuid}}" 
     [class.open]="expanded || pickerOpen"
     (click)="onDropdownClicked($event)">
    <input #selectedTextInputRef *ngIf="!disabled" class='form-control me-2'
           [(ngModel)]="selectedText"
           [readonly]="mobilePicker"
           [style.pointer-events]="mobilePicker ? 'none' : null"
           [attr.tabindex]="mobilePicker ? -1 : tabindex"
           (keyup)="onKeyUp($event)" 
           (keydown)="onKeyDown($event)" 
           (focus)="onDropdownClicked($event)"
           (click)="$event.stopPropagation()"
           [placeholder]='placeholder' />

    <input #selectedTextInputRef *ngIf="disabled" class='form-control me-2' 
           [ngModel]="selectedText" 
           tabindex="-1" 
           [readonly]="true" 
           [placeholder]='placeholder' />
    <div>
        <i class="fal fa-chevron-down me-2" style="pointer-events: none"></i>
    </div>
</div>


<ul *ngIf="isVisible" #dropdownList id="slick-drop-down_{{uuid}}" class='slick-drop-down-list-group dropdown-menu' 
    [style.width]="listGroupWidth" 
    [style.visibility]="(expanded === true) ? 'visible' : 'hidden'" 
    [style.opacity]="(expanded === true) ? '1' : '0'" 
    [style.max-height]="height" 
    [style.width.px]="listGroupWidth" 
    [style.left.px]="left" 
    [style.top.px]="top">
    <li *ngFor="let item of visibleItems; let index = index;" 
        (click)="onItemClick(item)" 
        [class.active]="item.id === selectedItem?.id" 
        [class.card-header]="selectedIndex === index"
        [style.border-top]="(item.item?.dividerBefore && index > 0) ? '1px solid rgba(128, 128, 128, .35)' : null"
        class="dropdown-item">{{item.text}}</li>
</ul>

<!-- Phones: a list of big tap targets over the whole screen in place of the list above. Moved to <body>
     while open so it covers Ionic's header and footers instead of sitting under them. Long lists get
     a search box, which only brings up the keyboard if the tech taps into it. -->
<div *ngIf="pickerOpen" #mobilePickerRef class="slick-drop-down-picker-backdrop" [class.has-search]="showPickerSearch" (click)="closePicker()">
    <div class="slick-drop-down-picker" (click)="$event.stopPropagation()">
        <div *ngIf="showPickerSearch" class="slick-drop-down-picker-header">
            <input type="search" class="form-control" placeholder="Search" [(ngModel)]="filterText" (ngModelChange)="onPickerSearch()" />
            <button type="button" class="slick-drop-down-picker-close" aria-label="Close" (click)="closePicker()">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>
        <div #mobilePickerListRef class="slick-drop-down-picker-list" role="listbox">
            <button type="button"
                    *ngFor="let item of visibleItems"
                    class="slick-drop-down-picker-option"
                    role="option"
                    [class.selected]="item.id === selectedItem?.id"
                    [attr.aria-selected]="item.id === selectedItem?.id"
                    (click)="onPickerItemClick(item)">
                <span>{{ item.text }}</span>
                <i *ngIf="item.id === selectedItem?.id" class="bi bi-check-lg"></i>
            </button>
            <div *ngIf="!visibleItems?.length" class="slick-drop-down-picker-empty">
                {{ filterText ? 'No matches' : 'Nothing to choose from' }}
            </div>
        </div>
    </div>
</div>
